import round from 'lodash.round';
var LodashService = /** @class */ (function () {
    function LodashService() {
    }
    LodashService.round = round;
    return LodashService;
}());
export { LodashService };
